<template>
  <div class="head w_100" :class="navChange ? 'fixed' : ''">
    <div class="topNavBox w_100" :class="navChange ? 'navbg' : ''">
      <div class="topBox auto flex align_c justify_between">
        <span class="left">欢迎使用宏钜金属网站购物！</span>
        <div class="right flex align_c">
          <div class="shop">
            <span class="cursor" @click="jumpto('coupon')">
              <img style="height: 20px" src="../assets/yhq.png" alt="" />
            </span>
          </div>
          <div class="line"></div>
          <div class="shop">
            <span
              class="el_icon el-icon-shopping-cart-1 cursor hover"
              @click="jumpto('car')"
              >购物车</span
            >
          </div>
          <div class="line"></div>
          <div class="shop">
            <span class="cursor hover" @click="jumpto('mine')">我的订单</span>
          </div>
          <div class="line"></div>
          <div class="shop">
            <div v-if="vip == 1" class="vipBox"></div>
            <div v-else-if="vip == 2" class="vipBox2"></div>
            <div v-else class="vipBox3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomNavBox w_100" :class="navChange ? 'navbg2' : ''">
      <div class="navBox auto flex align_c justify_around">
        <div class="logoImg" @click="jumpto('index')">
          <img :src="logo" alt="" />
        </div>
        <div class="name flex align_c hover">
          <img src="../assets/class.png" alt="" />
          <span class="cursor" @click="jumpto('list')">分类查询</span>
          <div class="element-search-warp">
            <div class="element-search2 auto flex justify_between">
              <div
                class="item"
                :class="currt == index ? 'on' : ''"
                v-for="(item, index) in fu_class"
                :key="index"
                v-on:mouseenter="handleMouseEnter(index)"
              >
                <div class="title cursor">
                  <span class="name" :class="item.icon" @click="jumpList(item)"
                    >&nbsp;{{ item.name }}</span
                  >
                </div>
              </div>
            </div>
            <div class="class_box flex">
              <div
                class="class_tit flex flex_column align_c cursor hover"
                v-for="(item, index) in childArr"
                :key="index"
                @click="jumpList2(item)"
              >
                <img :src="item.image" alt="" />
                <span> {{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="name flex align_c hover">
          <img src="../assets/yuansu.png" alt="" />
          <span class="cursor">元素查询</span>
          <div class="element-search-warp">
            <div class="element-search auto">
              <div class="title">点击可查询包含该元素所有产品信息</div>
              <ul class="">
                <li
                  v-for="(item, index) in yuanList"
                  :key="index"
                  :class="item.status"
                  @click="jumpTo2(item)"
                >
                  <a
                    >{{ item.title }}<span>{{ item.name }}</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="searchBox">
          <div class="search">
            <el-input
              placeholder="请输入CAS号、产品名称、产品编号"
              v-model="input"
              class="input-with-select"
            >
              <el-select v-model="select" slot="prepend" placeholder="请选择">
                <el-option label="宏钜产品" value="1"></el-option>
                <el-option label="技术文件" value="2"></el-option>
              </el-select>
              <el-button
                slot="append"
                @click="searchTo(select)"
                @keyup.enter.native="searchEnterFun"
                >搜索</el-button
              >
            </el-input>
          </div>
          <div class="yslist flex align_c justify_between">
            <span
              class="item cursor hover"
              v-for="(item, index) in fontList"
              :key="index"
              @click="jumpTo(item.title)"
              >{{ item.title }}</span
            >
          </div>
        </div>
        <div class="userInfo flex align_c cursor">
          <img
            :src="isToken ? user_avatar : '../assets/user.png'"
            alt=""
            @click="jumpto('mine')"
          />
          <div class="userName">
            <div class="strong m_b_6 cursor" @click="jumpto('mine')">
              {{ isToken ? user_name : 'Hi~上午好' }}
            </div>
            <div class="flex align_c">
              <div
                v-if="!isToken"
                class="hover cursor f_c_grey f_s_16 underline m_b_6"
                @click="jumpto('designates')"
              >
                注册
              </div>
              <div v-if="!isToken" class="line"></div>
              <div
                v-if="!isToken"
                class="hover cursor f_c_grey f_s_16 underline m_b_6"
                @click="jumpto('login')"
              >
                登录
              </div>
            </div>
            <div v-if="!isToken" class="f_s_12">登陆宏钜后更多优惠</div>
            <div v-else-if="isToken" class="flex align_c">
              <span
                class="hover cursor f_c_grey f_s_12"
                @click="jumpto('login')"
                >切换账号</span
              >
              <div class="line"></div>
              <span class="hover cursor f_c_grey f_s_12" @click="Exit"
                >退出</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  element,
  userInfo,
  getShopCategory,
  getsearch,
  index,
} from '../api/basisMG'
export default {
  name: 'Hd',
  props: {
    navChange: Boolean,
  },
  data() {
    return {
      input: '',
      select: '1',
      show: false,
      yuanList: [],
      vip: 1,
      allClass: [],
      fu_class: [],
      fontList: [],
      isToken: false,
      user_name: '',
      user_avatar: '',
      currt: 0,
      childArr: [],
      logo: '',
    }
  },
  created() {
    index().then((res) => {
      this.logo = res.data.logo
    })
    this.searchEnterFun()
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.isToken = true
    }
    this.getElement()
    this.getClass()
    this.getsearch()
  },
  methods: {
    searchEnterFun() {
      document.onkeyup = (e) => {
        // 为了更加严谨所以添加了路由路径的判断
        if (e.keyCode === 13) {
          //回车后执行搜索方法
          this.searchTo(this.select)
        }
      }
    },
    jumpto(page) {
      this.$router.push({ name: page })
    },
    jumpList(item) {
      const routeData = {
        name: 'list',
        query: {
          type: item.id,
        },
      }
      const resolvedRoute = this.$router.resolve(routeData)
      window.open(resolvedRoute.href, '_blank')
    },
    jumpList2(item) {
      const routeData = {
        name: 'list',
        query: {
          type: item.pid,
          label: item.id,
        },
      }
      const resolvedRoute = this.$router.resolve(routeData)
      window.open(resolvedRoute.href, '_blank')
    },
    getsearch() {
      getsearch().then((res) => {
        if (res.code == 1) {
          this.fontList = res.data
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg,
          })
        }
      })
    },
    getClass() {
      getShopCategory().then((res) => {
        if (res.code == 1) {
          this.allClass = res.data
          // const newarr = res.data.filter((item) => item.pid == 0);
          // this.fu_class = newarr;
          this.getChild(res.data, 0)
          this.childArr = this.fu_class[0].children
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg,
          })
        }
      })
    },
    getChild(list, pid = 0) {
      let newArr = []
      list.forEach((item) => {
        if (item.pid === pid) {
          item.children = this.getChild(list, item.id)
          newArr.push(item)
        }
      })
      this.fu_class = newArr
      return newArr
    },
    handleMouseEnter(i) {
      this.currt = i
      this.childArr = this.fu_class[i].children
    },
    jumpTo(text) {
      const routeData = {
        name: 'list',
        query: {
          keywords: text,
        },
      }
      const resolvedRoute = this.$router.resolve(routeData)
      window.open(resolvedRoute.href, '_blank')
    },
    jumpTo2(item) {
      if (item.status == 'normal') {
        const routeData = {
          name: 'list',
          query: {
            id: item.id,
          },
        }
        const resolvedRoute = this.$router.resolve(routeData)
        window.open(resolvedRoute.href, '_blank')
      }
    },
    searchTo(type) {
      if (type == 1) {
        const routeData = {
          name: 'list',
          query: {
            keywords: this.input,
          },
        }
        const resolvedRoute = this.$router.resolve(routeData)
        window.open(resolvedRoute.href, '_blank')
      } else if (type == 2) {
        const routeData = {
          name: 'newsList',
          query: {
            keywords: this.input,
          },
        }
        const resolvedRoute = this.$router.resolve(routeData)
        window.open(resolvedRoute.href, '_blank')
      } else {
        this.$notify.error({
          title: '错误',
          message: '请选择搜索内容',
        })
      }
    },
    getElement() {
      element().then((res) => {
        if (res.code == 1) {
          let newList = {
            name: '',
            title: '',
            status: 'empty',
          }
          for (var i = 1; i < 126; i++) {
            const newarr = res.data.find((item) => item.weigh === i)
            if (newarr) {
              this.yuanList.push(newarr)
            } else {
              this.yuanList.push(newList)
            }
          }
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg,
          })
        }
      })
      userInfo().then((res) => {
        if (res.code == 1) {
          this.vip = res.data.level
          this.isToken = true
          this.user_name = res.data.username
          this.user_avatar = res.data.avatar
        }
      })
    },
    Exit() {
      window.localStorage.clear()
      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  transition: top 0.2s ease 0s;
}
.head {
  top: 0;
  z-index: 999;
}
.topNavBox {
  background: $color_white;
  .topBox {
    padding: 5px 8px;
    max-width: $max_width;
    min-width: $min_width;
    font-size: $size_14;
    span {
      font-size: $size_14;
    }
    .vipBox {
      width: 24px;
      height: 24px;
    }
    .vipBox2 {
      width: 24px;
      height: 24px;
    }
    .vipBox3 {
      width: 24px;
      height: 24px;
    }
  }
}
.bottomNavBox {
  position: relative;
}
.navBox {
  max-width: $max_width;
  min-width: $min_width;
  padding: 10px 0;
  .logoImg {
    // width: 50px;
    // height: 50px;
    width: 215px;
    height: 50px;
    img {
      width: 100%;
    }
  }
  .name {
    height: 90px;
    font-family: 'iconfont' !important;
    img {
      margin-right: 8px;
    }
    &:hover {
      .element-search-warp {
        display: block !important;
      }
    }
    .element-search-warp {
      position: absolute;
      left: 0;
      right: 0;
      top: 100px;
      display: none;
      padding-bottom: 20px;
      background: $color_white;
      z-index: 999999;
      .element-search {
        height: 503px;
        width: 1300px;
        .title {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          color: $color_red;
          top: 35px;
          z-index: 9;
        }
        .hidden {
          background: #f5f5f5;
          a {
            color: #bbb;
          }
          span {
            color: #bbb;
          }
        }
        li {
          width: 68px;
          height: 62px;
          background-color: #eeeeee;
          position: relative;
          float: left;
          padding: 0 2px;
          margin: 0 1px 1px 0;
          padding-top: 7px;
          overflow: hidden;
          text-align: center;
          a {
            color: $color_red;
            font-weight: bold;
            height: 55px;
            line-height: 27px;
            display: inline-block;
            padding: 0 2px;
            font-size: 24px;
          }
          span {
            display: block;
            line-height: 1;
            font-size: 15px;
            color: $color_red;
            font-weight: normal;
          }
        }
        .empty {
          border: none;
          box-shadow: none;
          cursor: default;
          background-color: #fff;
        }
        .normal {
          &:hover {
            background-color: $color_red;
            a {
              // border-color: #bfd2ec;
              color: #fff;
            }
            span {
              color: #fff;
            }
          }
        }
      }
      .element-search2 {
        width: 1300px;
        padding: 20px 0;
        .item {
          // width: 14%;
          // padding: 0 30px;
          .name {
            color: #2c3e50;
            height: fit-content;
          }
          :deep(.fa)::before {
            font-size: 16px;
            margin-right: 10px;
          }
        }
        .on {
          .name {
            position: relative;
            color: $color_red;
            &::after {
              content: '';
              display: inline-block;
              width: 70px;
              height: 2px;
              background-color: $color_red;
              position: absolute;
              left: 0;
              bottom: -8px;
            }
          }
        }
        .item:last-child {
          border: 0;
        }
      }
      .class_box {
        width: 1300px;
        margin: 16px auto;
        flex-wrap: wrap;
        .class_tit {
          border-right: 1px solid $color_border;
          color: #2c3e50;
          font-size: 14px;
          width: 16%;
          img {
            width: 50px;
            margin-bottom: 15px;
          }
        }
        .class_tit:nth-child(6n) {
          border-right: 0;
        }
      }
    }
  }
  .searchBox {
    .search {
      border: 1px solid $color_red;
      border-radius: 4px;
      overflow: hidden;
    }
    .yslist {
      width: 500px;
      .item {
        display: inline-block;
        color: $color_grey;
        margin-top: 6px;
        font-size: 13px;
      }
    }
    :deep(.el-input__inner) {
      border: 0;
      height: 40px;
      border-right: 1px solid $color_border;
    }
    :deep(.el-input-group__append) {
      background: $color_red;
      border-radius: 3px;
      overflow: hidden;
      color: $color_white;
    }
  }
}
.navbg {
  background: $color_bg;
}
.navbg2 {
  background: $color_white;
  box-shadow: 0 3px 4px #ddd;
}
.userInfo {
  img {
    width: 60px;
    height: 60px;
    margin-right: 10px;
    border-radius: 50%;
  }
}
</style>
